// Libs
import { RouterProvider } from 'react-router/dom';

// Components
import Devtools from './shared/components/Devtools';
import IdentifyListener from './shared/utils/IdentityListener';
import Toaster from '~fpu/shared/components/Toaster';

// Hooks
import { useEnabledFeatureFlags } from './shared/hooks/useFeatureFlag';
import { useUserQuery } from './shared/global-queries';

// Utils
import { register } from './shared/axios-interceptors';
import { router } from './routes';

register();

const App = () => {
  const { data: user } = useUserQuery();

  // Prefetch enabled feature flags
  useEnabledFeatureFlags();

  return (
    <>
      <IdentifyListener userId={user?.axid} />
      <RouterProvider router={router} />
      <Toaster />
      <Devtools />
    </>
  );
};

export default App;
